import React, { useState, useContext } from 'react';
import OtpInput from 'react-otp-input';
import { IoCloseSharp } from 'react-icons/io5';
import { PropsFromRedux } from '.';
import { API_KEYS } from '../../interfaces/api';
import  './ConfirmTransactionPin.scss';
import BillsInfoContext from '../../context/BillsInfoContext/BillsInfoContext';
import { USER } from '../../interfaces/auth.interface';
import { BeatLoader, Spinner } from '../Spinners/Spinner';

interface Props extends PropsFromRedux {}

const ConfirmTransactionPin: React.FC<Props> = ({ 
    hideModal,
    showModal,
    modal,
    user,
    verifypin,
    resetApi,
    verifypinState,
    chargeWallet,
    getChargeState,
    sendPayAdvice,
    sendPayAdviceState,
    validatepayment,
    validatePaymentState
 }) => {

    const  { dataObj, setDataObj} = useContext(BillsInfoContext);
    const userObj: USER = user?.response?.Object;
    const referneceCode = modal?.ownProps?.refCode; 
    const dataInfo = modal?.ownProps?.data; 
    const [ref, setRef] = useState('');
    const [otp,setOtp] = useState('')
  
    const handleChange = (code:any) => { setOtp(code) }

    const verifyPin = () => {
        verifypin({ CustomerPin : otp });
    }
    const closeModal = () => {
        hideModal();
      };

  React.useEffect(
    () => () => {
      resetApi(API_KEYS.CHARGE_WALLET);
      resetApi(API_KEYS.SEND_PAY_ADVICE);
      resetApi(API_KEYS.VALIDATE_BILLS_PAYMENT);
      resetApi(API_KEYS.VERIFY_USER_PIN);
      resetApi(API_KEYS.VALIDATE_BILLS_PAYMENT)
    },
    [resetApi]
  );

  React.useEffect(() => () => {
    if(referneceCode) {
       setRef(referneceCode);
    }
 },
[setRef, referneceCode]);

// console.log('Data Object', dataObj);

    React.useEffect(() => {
          if(verifypinState?.success && !verifypinState?.loading && verifypinState?.response?.Object == true){
              // console.log('I got here');
              // const amount = dataObj?.Amount;
              // let newamount = amount;
              // if(dataObj.BillType === 'Data Bundle' || dataObj.BillType === 'TV Subscription') {
              //   newamount = amount / 100
              // }
              

              chargeWallet({
                UserId : userObj?.UserId,
                Amount : dataObj?.Amount,
                BillType : dataObj?.BillerType,
                ReferenceNo : referneceCode,
                Description : dataObj?.UtilityPlan?.paymentitemname
              })
          }
    },[verifypinState?.success, !verifypinState?.loading, verifypinState?.response?.Object, chargeWallet])



//     React.useEffect(() => {
//       if(sendPayAdviceState?.success ){
//         hideModal();
//       }
// },[sendPayAdviceState?.success])
    
  
      React.useEffect(() => {
      //   const amount = dataObj?.Amount;
      //   let newamount = amount;
      //  if(dataObj.BillType === 'Airtime' || dataObj.BillType === 'Electricity') {
      //    newamount =   amount * 100;
      //  } 

      if (getChargeState?.success && !getChargeState?.loading && getChargeState?.response?.Object.Succeeded == true) {
        sendPayAdvice({
          amount : dataObj?.Amount * 100,
          customerMobile : userObj.PhoneNumber,
          paymentCode: dataObj.PaymentCode,
          transactionType: dataObj?.TransactionType,
          requestReference: referneceCode,
          TerminalId: "3TCK0001",
          customerEmail: userObj.Email,
          customerId : dataObj?.CustomerId,
          paymentMethod : 1
        })
      }
      // console.log('sendPayAdvice Obj',getChargeState);
    }, [getChargeState?.success, getChargeState?.loading, sendPayAdvice]);

    // React.useEffect(() => {
    //   if(validatePaymentState?.success){
    //      showModal({
    //       component: 'BillSuccessful',
    //       modalProps: {
    //         contentLabel: 'Bill Successful Modal',
    //       }
    //     });
    //   }
    // })
  
    React.useEffect(() => {
    if(!sendPayAdviceState?.loading && sendPayAdviceState?.success){
      if (sendPayAdviceState?.response?.payload?.responseCodeGrouping === 'SUCCESSFUL') {
        showModal({
          component: 'BillSuccessful',
          modalProps: {
            contentLabel: 'Bill Successful Modal',
          }
        });
    }
    else {
      showModal({
        component: 'PaymentValidationTimer',
        modalProps: {
          contentLabel: 'Payment Validation Timer',
        },
        ownProps: {
          refCode: referneceCode
        }
      });
    }

    }
    }, [verifypinState?.success,!verifypinState?.loading,sendPayAdviceState?.response?.payload.responseCodeGrouping, showModal, validatepayment]);
  
    if (getChargeState?.loading || sendPayAdviceState?.loading) {
      return (
        <div className="w-full flex items-center justify-center pt-4 overflow-hidden">
          <Spinner color="#CCC" />
        </div>
      );
    }
  
    // <ModalWrapper hideCloseButton hideModal={hideModal}>
    return(
      <div className="w-full px-8 bg-white lg:px-24 py-10 relative">
                       <button type="button" aria-label="Close" onClick={closeModal}>
        <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
       <div className="w-full my-2 text-center">
           <h2 className="mb-1 text-2xl font-bold text-black">Confirm transaction</h2>
        </div>
        <div className="w-full max-w-md mx-auto text-center mb-10 text-sm">
          <p className="text-gray-500 my-4">
              Complete this transaction by confirming  your wallet pin
         </p>
         <div>
         <OtpInput 
         inputStyle="otp-field"
          value={otp}
          onChange={handleChange}
          numInputs={4}
          isInputSecure={true}
          separator={<span> </span>}
        />
         </div>
        </div>
        <button className="w-full bg-secondary font-medium text-sm rounded text-white py-4" type="button" onClick={() => verifyPin()}
        disabled={verifypinState?.loading}
        >{verifypinState?.loading ? <BeatLoader color="white" /> : 'Confirm'}
        
        
        </button>
            {/* {otp.length == 4 && otp !== walletpin ? (<p className="text-red-600 text-center m-2">Pin don't match</p>) : (
            <div className="text-center">
               <span className="inline-flex items-center">
                    <p className="text-red-600 text-xs"> </p>
              </span>
            </div>
             )} */}
    </div>
    );
  };
  
  export default ConfirmTransactionPin;
  
